import React, { useState } from "react";
import DeleteButton from "@/ui-controls/DeleteButton";
import CancelButton from "@/ui-controls/CancelButton";
import TextInput from "@/ui-controls/TextInput";
import { Grid } from "fluentui-react-grid";
import { IconButton, Stack, Text } from "@fluentui/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Customer,
  deleteCustomer as deleteCustomerApi,
} from "@/api/customers";

interface Props {
  customer: Customer;
  onDelete?: (customer: Customer) => any;
  onClose?: () => any;
}

const DeleteCustomerForm = (props: Props) => {
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };
  const handleCopyName = async () => {
    if (!props.customer?.Name) {
      return;
    }
    try {
      await navigator.clipboard.writeText(props.customer.Name);
    } catch {
      const textArea = document.createElement("textarea");
      textArea.value = props.customer.Name;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
  };

  const deleteCustomer = () => {
    setIsDeleting(true);

    deleteCustomerApi(props.customer.Id).then(
      (result: boolean) => {
        setIsDeleting(false);
        if (result) {
          if (props.onDelete) props.onDelete(props.customer);
        }
      },
      (error) => {
        setIsDeleting(false);
        handleError(error);
      },
    );
  };

  const formik = useFormik({
    initialValues: { name: "" },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Name is required")
        .max(250)
        .oneOf([props.customer?.Name], "Invalid customer name"),
    }),
    onSubmit: (values) => {
      deleteCustomer();
    },
  });

  const handleError = (error: any) => {};

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              {props.customer && (
                <Stack
                  horizontal
                  verticalAlign="center"
                  tokens={{ childrenGap: 8 }}
                  styles={{ root: { marginBottom: "8px" } }}
                >
                  <Text
                    variant="smallPlus"
                    styles={{ root: { fontWeight: 600 } }}
                  >
                    {props.customer.Name}
                  </Text>
                  <IconButton
                    iconProps={{ iconName: "Copy" }}
                    title="Copy customer name"
                    ariaLabel="Copy customer name"
                    onClick={handleCopyName}
                  />
                </Stack>
              )}
              <TextInput
                label="Confirm Customer Name"
                baseTypeProps={{
                  disabled: isDeleting,
                  ...formik.getFieldProps("name"),
                }}
                hasError={formik.errors.name && formik.touched.name}
                errorMessage={formik.errors.name}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <DeleteButton
                text="Delete"
                baseTypeProps={{ type: "submit", disabled: isDeleting }}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: isDeleting }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </form>
    </>
  );
};

export default DeleteCustomerForm;
